import View from './View';
import Container from './Container';

export * from './components';

export default Container(View);
